// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.au-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--admin-s4);
  min-height: 44px;
  padding: var(--admin-s3) 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.au-toolbar__meta,
.au-toolbar__heading,
.au-toolbar__actions {
  display: flex;
  align-items: center;
  min-width: 0;
}

.au-toolbar__meta {
  gap: var(--admin-s3);
}

.au-toolbar__heading {
  gap: var(--admin-s3);
  min-width: 0;
}

.au-toolbar__label {
  color: var(--admin-text-primary);
  font-size: var(--admin-text-md);
  font-weight: var(--admin-font-weight-semibold);
  letter-spacing: var(--admin-tracking-tight);
}

.au-toolbar__count {
  display: inline-flex;
  align-items: center;
  min-height: 18px;
  padding: 0 7px;
  border: var(--admin-border-subtle);
  border-radius: var(--admin-radius-md);
  background: var(--admin-bg-surface-1);
  color: var(--admin-text-secondary);
  font-size: var(--admin-text-xs);
  font-weight: var(--admin-font-weight-semibold);
}

.au-toolbar__actions {
  gap: var(--admin-s2);
  margin-left: auto;
}

@media (max-width: 880px) {
  .au-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .au-toolbar__actions {
    justify-content: flex-end;
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/ui/AdminToolbar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,kDAAkD;AACpD;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,8CAA8C;EAC9C,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,qCAAqC;EACrC,qCAAqC;EACrC,kCAAkC;EAClC,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;AACF","sourcesContent":[".au-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--admin-s4);\n  min-height: 44px;\n  padding: var(--admin-s3) 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.au-toolbar__meta,\n.au-toolbar__heading,\n.au-toolbar__actions {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n}\n\n.au-toolbar__meta {\n  gap: var(--admin-s3);\n}\n\n.au-toolbar__heading {\n  gap: var(--admin-s3);\n  min-width: 0;\n}\n\n.au-toolbar__label {\n  color: var(--admin-text-primary);\n  font-size: var(--admin-text-md);\n  font-weight: var(--admin-font-weight-semibold);\n  letter-spacing: var(--admin-tracking-tight);\n}\n\n.au-toolbar__count {\n  display: inline-flex;\n  align-items: center;\n  min-height: 18px;\n  padding: 0 7px;\n  border: var(--admin-border-subtle);\n  border-radius: var(--admin-radius-md);\n  background: var(--admin-bg-surface-1);\n  color: var(--admin-text-secondary);\n  font-size: var(--admin-text-xs);\n  font-weight: var(--admin-font-weight-semibold);\n}\n\n.au-toolbar__actions {\n  gap: var(--admin-s2);\n  margin-left: auto;\n}\n\n@media (max-width: 880px) {\n  .au-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .au-toolbar__actions {\n    justify-content: flex-end;\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
